import type { PrimeConfig } from '#types/config/components/prime'
import type { RecursivePartial } from '#types/utils'

export default {
  attributes: {
    'border-radius': '4px',
    'corner-style': 'custom',
    'font-size-base': '19px',
    'show-explainer': true
  }
} satisfies RecursivePartial<PrimeConfig['deliveryCard']>
